import { gql } from '@apollo/client';

export const DELETE_NON_WORKING_DAY = gql`
  mutation deleteNonWorkingDay($id: Int!) {
    deleteNonWorkingDay(id: $id) {
      commandId
      correlationId
    }
  }
`;
